import React from 'react'

const BusinessCardWorks = () => {
  return (
    <>
        <div className='business_Card_Works_wrapper'>
        <div className='business_card_works_content'>
        <h3>How It Works?</h3>
    <h6>Make a digital business card</h6>
        <h5>Enter your company information, 
        provide your personal details, 
        create your card with a 
        QR code for your brand or business, 
        and make a memorable impact. It's easy!</h5>


        <h6>Share and receive contacts</h6>
        <h5>
        Share your digital business card with anyone with ease by sending it via email,
         a link, or a QR code and save it in your directory. 
        You can download QR codes to print on flyers, newsletters, 
        or billboards, among other materials.</h5>



        <h6>Grow Your Customers</h6>
        <h5>
        Optimal frictionless experience: 
        Neoo Search makes it easy to overcome any new cleanliness resistance.
         Its viral characteristics also help you build professional partnerships.
          A virtual business card can be sent or received without any physical contact. 
          Create a card for each of your friends, 
        clients, and business associates.</h5>
  
    </div>
        </div>
    </>
  )
}

export default BusinessCardWorks